import {createSlice} from '@reduxjs/toolkit';
import {httpPost, httpGet} from '../../../../util/Rest';
import {CLIENT_MAINTENANCE} from '../../../../constants/MicroServiceConstants';
import {
  SCRIPT_TABLE,
  CANC_CNTRL_TBL,
  CLNT_DISP_LIST,
  MINIMUM_SETTLEMENT,
  CLNT_LTR_LIST,
  ACCOUNT_WORK,
} from '../../../../constants/Lookup';

const initialData = {
  collectData: {},
  dropDownData: {},
  collectStatus: null,
  isLoading: false,
  errorMsg: null,
  successMsg: null,
  letterControlListDropdownData: [],
};

const slice = createSlice({
  name: 'CollectScreen',
  initialState: {
    ...initialData,
  },
  reducers: {
    fetchStart: (state) => {
      state.isLoading = true;
      state.errorMsg = null;
    },
    fetchCollectData: (state, action) => {
      state.collectData = action.payload;
      state.isLoading = false;
      state.errorMsg = null;
    },
    getLetterControlListData: (state, action) => {
      state.letterControlListDropdownData = action.payload;
      state.isLoading = false;
      state.errorMsg = null;
    },
    postCollectData: (state, action) => {
      state.collectStatus = action.payload.status;
      state.isLoading = false;
      state.errorMsg = null;
      state.successMsg = action.payload.response;
    },
    fetchDropDownData: (state, action) => {
      state.dropDownData = action.payload;
      state.isLoading = false;
      state.errorMsg = null;
    },
    resetCollect: (state) => {
      state.collectStatus = null;
      state.isLoading = false;
    },
    fetchError: (state, action) => {
      state.errorMsg = action.payload;
      state.isLoading = false;
    },
    resetMsg: (state, action) => {
      state.successMsg = null;
      state.errorMsg = null;
      state.isLoading = false;
    },
  },
});

export default slice.reducer;

// Actions

const {
  fetchStart,
  fetchCollectData,
  postCollectData,
  resetCollect,
  resetMsg,
  fetchDropDownData,
  getLetterControlListData,
  fetchError,
} = slice.actions;
export const fetchCollect = (clientNumber) => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpGet(`${CLIENT_MAINTENANCE}/find/collectscreen/${clientNumber}`)
      .then((data) => {
        if (data && data.status && data.status === 200) {
          dispatch(fetchCollectData(data.response));
        } else {
          dispatch(fetchError(data?.data?.error));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error?.data?.error));
      });
  };
};

export const fetchDropdown = () => {
  return (dispatch) => {
    httpPost(`lookup/find/all/lookup`, {
      typeCode: [
        SCRIPT_TABLE,
        CANC_CNTRL_TBL,
        CLNT_DISP_LIST,
        MINIMUM_SETTLEMENT,
        CLNT_LTR_LIST,
        ACCOUNT_WORK,
      ],
    }).then((response) => {
      if (response?.status && response.status === 200) {
        dispatch(fetchDropDownData(response.data));
      } else {
        dispatch(fetchError(response?.data?.error));
      }
    })
      .catch((error) => {
        dispatch(fetchError(error.message));
      });
  };
};
export const postCollect = (details) => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpPost(`${CLIENT_MAINTENANCE}/save/collectscreen`, details)
      .then((data) => {
        if (data && data.status && data.status === 200) {
          dispatch(postCollectData(data));
        } else {
          dispatch(fetchError(data?.data?.error));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error.message));
      });
  };
};
export const getLetterDropdownData = () => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpGet(`lettermaintenance/find/all/listcodeanddesc`)
      .then((data) => {
        if (data.status === 200 && data?.data?.status === 400) {
          dispatch(fetchError(data));
        } else if (data && data?.status && data.status === 200) {
          dispatch( getLetterControlListData(data?.response));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error.message));
      });
  };
};

export const resetMessage = () => {
  return (dispatch) => {
    dispatch(resetMsg());
  };
};
export const resetStatus = () => {
  return (dispatch) => {
    dispatch(resetCollect());
  };
};
